import styled from "styled-components";

const S = {
    Wrapper: styled.div`
        width: 100%;
        /* height: 500px; */
        float: left;
        border-radius: 0px 0px 8px 8px;
        background-color:#f2f5f4;
        .slogan{
                    padding: 40px 45px 0px;
                    font-weight: bold;
                    color:#59bdd7;
                }
                .girismetni{
                    padding: 45px;
                    font-weight: 600;
                    color:gray;
                }
                .logintasi{
                  width: 400px;
                  min-height: 330px;
                  padding: 4px;
                  background-image: -webkit-linear-gradient(top, #fff, #eee);
                  margin: 220px auto 0 auto;
                  border-radius: 8px;
                  -webkit-box-shadow: 10px 0px 85px -29px rgba(0,0,0,0.30);
                  -moz-box-shadow: 10px 0px 85px -29px rgba(0,0,0,0.30);
                  box-shadow: 10px 0px 85px -29px rgba(0,0,0,0.30);
                  .logindash{
                      width: 400px;
                      min-height: 330px;
                      //background: white;
                      background-image: -webkit-linear-gradient(top, #fff, #eee);
                      border: 1px dashed #ccc;
                      //margin: 20px auto;
                      border-radius: 8px;
                      box-sizing: border-box;
                      padding: 35px 35px 10px 35px;
                      -webkit-box-shadow: 10px 0px 85px -29px rgba(0,0,0,0.30);
                      -moz-box-shadow: 10px 0px 85px -29px rgba(0,0,0,0.30);
                      box-shadow: 10px 0px 85px -29px rgba(0,0,0,0.30);
                      label{
                          width: 100%;
                          float: left;
                          font-size:24px;
                          font-weight: 600;
                          //color:$button-text-color;
                          color:#142e66;
                          letter-spacing: 4px;
                          margin-bottom: 20px;
                          text-align: center;
                          text-shadow: 0 1px 0 rgba(255, 255, 255, .7), 0px 2px 0 rgba(0, 0, 0, .5);
                      }
                      h1{
                          width: 100%;
                          float: left;
                          font-size:24px;
                          font-weight: 600;
                          //color:$button-text-color;
                          position: relative;
                          color:#142e66;
                          letter-spacing: 4px;
                          margin-bottom: 20px;
                          text-align: center;
                          text-shadow: 0 1px 0 rgba(255, 255, 255, .7), 0px 2px 0 rgba(0, 0, 0, .5);
                      }
                      h1:before {
                          background-image: -webkit-gradient(linear, right top, left top, from(#777), to(#fff));
                          background-image: -webkit-linear-gradient(right, #777, #fff);
                          background-image: -moz-linear-gradient(right, #777, #fff);
                          background-image: -ms-linear-gradient(right, #777, #fff);
                          background-image: -o-linear-gradient(right, #777, #fff);
                          //background-image: linear-gradient(right, #777, #fff);
                          left: 0;
                      }
                      h1:after {
                          background-image: -webkit-gradient(linear, left top, right top, from(#777), to(#fff));
                          background-image: -webkit-linear-gradient(left, #777, #fff);
                          background-image: -moz-linear-gradient(left, #777, #fff);
                          background-image: -ms-linear-gradient(left, #777, #fff);
                          background-image: -o-linear-gradient(left, #777, #fff);
                          //background-image: linear-gradient(left, #777, #fff);
                          right: 0;
                      }
                      h1:after, h1:before {
                          background-color: #777;
                          content: "";
                          height: 1px;
                          position: absolute;
                          top: 15px;
                          width: 120px;
                      }
                      input[type="text"]{
                          width: 100%;
                          float: left;
                          box-sizing: border-box;
                          border-radius: 8px;
                          border: 1px solid #ccc;
                          padding: 15px 15px 15px 30px;
                          margin: 0 0 10px 0;
                          transition: 300ms;
                          &:hover{
                              transition: 300ms;
                              border:2px solid #19B5FE;
                          }
                      }:focus {
                             outline:0;
                      }
                      input[type="password"]{
                          width: 100%;
                          float: left;
                          box-sizing: border-box;
                          border-radius: 8px;
                          border: 1px solid #ccc;
                          padding: 15px 15px 15px 30px;
                          margin: 0 0 10px 0;
                          transition: 300ms;
                          &:hover{
                              transition: 300ms;
                              border:2px solid #19B5FE;
                          }
                      }:focus {
                             outline:0;
                             border-color: #00AAFF;
                      }
                      input[type="submit"]{
                              float: left;
                              width: 120px;
                              //background: #19B5FE;
                              background: #00c6ff;  /* fallback for old browsers */
                              background: -webkit-linear-gradient(to right, #0072ff, #00c6ff);  /* Chrome 10-25, Safari 5.1-6 */
                              background: linear-gradient(to right, #0072ff, #00c6ff); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
                              border-radius: 4px;
                              border-style:none;
                              padding: 12px 20px;
                              text-decoration: none;
                              font-size: 15px;
                              box-sizing:border-box;
                              font-weight: 600;
                              margin-top:10px;
                              color:white;
                              cursor:pointer;
                              -webkit-transition: background 1s ease-out;
                             -moz-transition: background 0.5s ease-out;
                             -o-transition: background 0.5s ease-out;
                             transition: background 0.5s ease-out;
                              background-size:220px;
                              &:hover{
                                -webkit-transition: background 0.5s ease-out;
                               -moz-transition: background 0.5s ease-out;
                               -o-transition: background 0.5s ease-out;
                               transition: background 0.5s ease-out;
                                  //color:$button-text-color;
                                  color:white;
                                  background-position:-100px;
                                  //background: $content-backcolor;
                              }
                      }:focus {
                          outline:0;
                          transition: 500ms;
                      }
                      .logindurum{
                          margin-top: 10px;
                          widows: 100%;
                          float: left;
                      }
                      .logo{
                        float: right;
                        width: 120px;
                        height: 120px;
                        img{
                          width: 100%;
                          height: 100%;
                          object-fit: contain;
                        }
                      }
                  }
                }
    `,
}
export default S